import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

// PrimeNG
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';

// Composants
import { BaseComponent } from '../abstract/base.component';

export type MessageSeverity = 'info' | 'warn' | 'error' | 'secondary' | 'success' | 'help' | 'ai';
export type MessageButtonSeverity = 'info' | 'warn' | 'danger' | 'success' | 'help' | 'secondary';

export interface MessageAction {
    label: string;
    handler: () => void;
    loading?: boolean;
    /** Bouton grisé, non cliquable. */
    disabled?: boolean;
    /** Infobulle affichée au survol du bouton. */
    tooltip?: string;
}

@Component({
    selector: 'app-message',
    imports: [
        CommonModule,
        ButtonModule,
        MessageModule,
        TooltipModule,
    ],
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss']
})
export class MessageComponent extends BaseComponent {

    @Input() severity: MessageSeverity = 'info';
    @Input() buttonSeverity?: MessageButtonSeverity;
    @Input() icon?: string;
    @Input() title!: string;
    /** Libellé secondaire sur la ligne du titre, aligné à droite (un auteur, une date…). */
    @Input() titleNote?: string;
    @Input() messages?: string[];
    @Input() primaryAction?: MessageAction;
    @Input() secondaryActions?: MessageAction[];

    /** Sévérité transmise à p-message. 'help' et 'ai' sont gérés comme 'info' + styleClass dédiée. */
    public get pMessageSeverity(): string {
        return (this.severity === 'help' || this.severity === 'ai') ? 'info' : this.severity;
    }

    /** Classe CSS additionnelle sur p-message pour les variants 'help' (framboise) et 'ai' (violet). */
    public get pMessageStyleClass(): string {
        switch (this.severity) {
            case 'help': return 'help';
            case 'ai':   return 'ai';
            default:     return '';
        }
    }

    /** Sévérité effective des boutons, dérivée de severity si non surchargée. */
    public get effectiveButtonSeverity(): MessageButtonSeverity | undefined {
        if (this.buttonSeverity) return this.buttonSeverity;
        switch (this.severity) {
            case 'warn':      return 'warn';
            case 'error':     return 'danger';
            case 'success':   return 'success';
            case 'secondary': return 'secondary';
            case 'help':      return 'help';
            case 'ai':        return 'help';
            default:          return undefined;
        }
    }
}
